

// import React, { useEffect, useState } from "react";
// import "./JobList.css";
// import { GrFormNext, GrFormPrevious } from "react-icons/gr";
// import { fetchStyle } from "../Config/config";
// import styled from 'styled-components';
// import { BaseUrl } from "../UserData";

// const JobList = ({ jobs, error, renderHTML, navigateToDetails, city }) => {
//     const [theme, setTheme] = useState({});
//     const [isListView, setIsListView] = useState(false);
//     const [page, setPage] = useState(1);
//     console.log("jobs",jobs)
//     const styleUrl = `${BaseUrl}/customer/getEmbededCodeSettings?customerName=syra`;
//     useEffect(() => {
//         const fetchThemes = async () => {
//             const fetchedTheme = await fetchStyle(styleUrl);
//             console.log("Fetched Theme:", fetchedTheme);
//             setTheme(fetchedTheme);
//         };
//         fetchThemes();
//     }, []);
//     console.log("theme",theme)
//     // Global Theme Wrapper with CSS Variables
//     const ThemeWrapper = styled.div`
//         background-color: ${theme.bg_color};
        
//         /* Define global CSS variables */
//         --text-color: ${theme.text_color || "#333"};
//         --text-font: ${theme.text_font || "Arial, sans-serif"};
       
//         --button-bg: ${theme.button_color || "#0073e6"};
//         --button-hover-bg: ${theme.button_hover_color || "#005bb5"};
//     --bg-color:${theme.bg_color || "#ffffff"};
//         font-family: var(--text-font);
//         color: var(--text-color);
//         background-color: var(--bg-color);
//     `;

//     const Button = styled.button`
//         background-color: var(--button-bg);
//         color: #fff;
//         border: none;
//         padding: 8px 12px;
//         cursor: pointer;
//         transition: background-color 0.3s ease-in-out;

//         // &:hover {
//         //     background-color: var(--button-hover-bg);
//         // }

//         &.active {
//             font-weight: bold;
//             background-color: var(--button-hover-bg);
//         }
//     `;

//     const itemsPerPage = 6;
//     const totalPages = Math.ceil(jobs.length / itemsPerPage);

//     const selectedPage = (pages) => {
//         if (pages >= 1 && pages <= totalPages && pages !== page) {
//             setPage(pages);
//         }
//     };

//     function ensureMySQLDateTime(dateTimeString) {
//         if (!dateTimeString) return null;
        
//         const parsedDate = new Date(dateTimeString);
//         if (isNaN(parsedDate.getTime())) return null;

//         const year = parsedDate.getFullYear();
//         const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
//         const day = String(parsedDate.getDate()).padStart(2, '0');
//         const hours = String(parsedDate.getHours()).padStart(2, '0');
//         const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
//         const seconds = String(parsedDate.getSeconds()).padStart(2, '0');

//         return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//     }

//     const renderJobs = () => {
//         if (error) {
//             return <p>Error loading jobs: {error}</p>;
//         }
//         if (!Array.isArray(jobs) || jobs.length === 0) {
//             return <p>No jobs available at the moment.</p>;
//         }

//         const startIndex = (page - 1) * itemsPerPage;
//         const endIndex = startIndex + itemsPerPage;
//         const jobsToRender = jobs.slice(startIndex, endIndex);

//         return jobsToRender.map((job, index) => {
        

//             return (
//                 <ThemeWrapper key={index} className={`job-item ${isListView ? "list-view" : "card-view"}`}>
//                     <div className="job-header">
//                         <p>
//                             <span>{job?.job_country.toUpperCase()}</span> | <span>{job?.job_city.toUpperCase()}</span>
//                         </p>
//                     </div>

//                     <h2>
//                         <a
//                             href="#"
//                             className="job-title-link"
//                             onClick={(e) => {
//                                 e.preventDefault();
//                                 navigateToDetails(job?.job_id);
//                             }}
//                         >
//                             {job?.job_title}
//                         </a>
//                     </h2>

//                     <p className="job-description">{renderHTML(job?.job_description?.split(' ').slice(0,10).join(' ')+'...')}</p>
//                     <p>
//                         <strong className="sub-heading">Years of Experience:</strong> 1 - 2
//                     </p>
//                     <p>
//                         <strong className="sub-heading">Posted: </strong>{job?.created_at}
//                     </p>
//                 </ThemeWrapper>
//             );
//         });
//     };

//     return (
//         <ThemeWrapper className="main-container">
//             <div className="view-toggle">
//                 <Button onClick={() => setIsListView(false)} className={!isListView ? "active" : ""}>
//                     Card View
//                 </Button>
//                 <Button onClick={() => setIsListView(true)} className={isListView ? "active" : ""}>
//                     List View
//                 </Button>
//             </div>
//             <div className="job-container">{renderJobs()}</div>
//             {jobs.length > 0 && (
//                 <div className="pagination">
//                     <span onClick={() => selectedPage(page - 1)}><GrFormPrevious size={25} /></span>
//                     {[...Array(totalPages)].map((_, i) => (
//                         <span 
//                             key={i} 
//                             onClick={() => selectedPage(i + 1)} 
//                             className={page === i + 1 ? "selectedPage" : ""}
//                         >
//                             {i + 1}
//                         </span>
//                     ))}
//                     <span onClick={() => selectedPage(page + 1)}><GrFormNext size={25} /></span>
//                 </div>
//             )}
//         </ThemeWrapper>
//     );
// };

// export default JobList;

import React, { useEffect, useState } from "react";
import "./JobList.css";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { fetchStyle } from "../Config/config";
import styled from "styled-components";
import { BaseUrl } from "../UserData";
import { MdLocationOn } from "react-icons/md";
import JobDetails from "../JobDetails/JobDetails";
import { useNavigate, useSearchParams } from "react-router-dom";




export const ThemeWrapper = styled.div`
  background-color: ${(props) => props.theme.bg_color || "#ffffff"};

  /* Define global CSS variables */
  --text-color: ${(props) => props.theme.text_color || "#333"};
  --text-font: ${(props) => props.theme.text_font || "Arial, sans-serif"};
  --button-bg: ${(props) => props.theme.button_color || "#0073e6"};
  --button-hover-bg: ${(props) => props.theme.button_hover_color || "#005bb5"};
  --bg-color: ${(props) => props.theme.bg_color || "#ffffff"};

  font-family: var(--text-font);
  color: var(--text-color);
  background-color: var(--bg-color);
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
`;

export const SearchContainer = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px 32px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-bottom: 24px;
  box-sizing: border-box;
`;

export const SearchForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }

  input {
    flex: 1;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;

  svg {
    position: absolute;
    left: 12px;
    color: #9ca3af;
    width: 20px;
    height: 20px;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 12px 16px 12px 40px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  background-color: #ffffff;
  font-family: var(--text-font);
  color: var(--text-color);

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    border-color: var(--button-bg);
  }
`;

export const ViewJobsButton = styled.button`
  background-color: var(--button-bg);
  color: #ffffff;
  border: none;
  padding: 13px 32px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const FormLabel = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb;
  padding: 8px 12px;
  background-color: #ffffff;
  border-radius: 8px;
  flex: 1;

  label {
    font-size: 11px;
    color: #6b7280;
    font-weight: 500;
    margin-bottom: 4px;
    font-family: var(--text-font);
  }

  select {
    border: none;
    outline: none;
    font-size: 14px;
    color: var(--text-color);
    background-color: transparent;
    cursor: pointer;
    padding: 0;
    font-family: var(--text-font);
  }
`;

export const ContentWrapper = styled.div`
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  padding: 40px 24px 40px 24px;
  background-color: var(--bg-color);
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 40px 16px;
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const JobCount = styled.p`
  color: var(--text-color);
  font-size: 14px;
  font-weight: 400;
  margin: 0;
`;

export const ViewToggle = styled.div`
  display: flex;
  gap: 0;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  background-color: #ffffff;
`;

export const ToggleButton = styled.button`
  background-color: ${(props) => (props.active ? "var(--button-bg)" : "transparent")};
  color: ${(props) => (props.active ? "#fff" : "#000")};
  border: ${(props) => (props.active ? "1px solid #e5e7eb" : "none")};
  border-radius: ${(props) => (props.active ? "4px" : "0")};
  padding: 8px 20px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: ${(props) => (props.active ? "500" : "400")};
  font-size: 13px;
  margin: ${(props) => (props.active ? "2px" : "0")};
`;

export const JobContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 24px;
  align-items: stretch;
  width: 100%;
  padding: 0 20px;  
   justify-content: center;
  box-sizing: border-box;

  &.list-view {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const JobCard = styled.div`
  border: 1px solid var(--button-bg);
  border-radius: 12px;
  background-color: #ffffff;
  padding: 15px 20px;
 width: 100%;                  /* ← make sure this is present */
  max-width: none;              /* ← ADD THIS: removes the 350px cap that was causing conflict */
  min-width: 0;                 /* ← ADD THIS: prevents overflow/overlap on small grid cells */
  min-height: 200px;            /* ← optional but recommended for consistent height */
  overflow: hidden;             /* ← ADD THIS: prevents content from breaking card layout */
  box-sizing: border-box;
  justify-self: center;
  display: flex;
  flex-direction: column;
  gap: 2px;
  transition: all 0.25s ease;
  cursor: pointer;
  justify-content: space-between;
height: 100%;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }

  .job-card-footer {
  margin-top: auto;
}
  .job-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;

    .experience-badge {
      background-color: #f5f3ef;
      color: var(--text-color);
      font-size: 12px;
      padding: 4px 6px;
      border-radius: 4px;
      font-weight: 400;
    }

    .location-info {
      display: flex;
      align-items: center;
      gap: 4px;
      color: var(--text-color);
      font-size: 12px;
      margin-left: auto;

      svg {
        width: 14px;
        height: 14px;
        color: var(--button-bg);
      }
    }
  }

  h2 {
    font-size: 18px;
    font-weight: 700;
    margin: 10px 0;
    color: var(--text-color);
    line-height: 1.3;

    .job-title-link {
      text-decoration: none;
      color: inherit;

      &:hover {
        color: var(--button-bg);
      }
    }
  }

  .job-description {
    font-size: 12px;
    color: var(--text-color);
    opacity: 0.85;
    line-height: 1.6;
    margin: 0;
  }

  .job-posted {
    font-size: 12px;
    color: var(--text-color);
    opacity: 0.7;
    margin-top: auto;
  }
`;
// export const JobCard = styled.div`
//   border: 1px solid var(--button-bg);
//   border-radius: 12px;
//   background-color: #ffffff;
//   padding: 20px;               // ← increased padding a bit
//   width: 100%;
//   max-width: 380px;            // ← slightly wider looks better
//   min-height: 320px;           // ← IMPORTANT: fixed minimum height
//   max-height: 380px;           // ← prevents cards from becoming too tall
//   display: flex;
//   flex-direction: column;
//   gap: 12px;
//   transition: all 0.25s ease;
//   cursor: pointer;
//   overflow: hidden;            // ← prevents content overflow

//   &:hover {
//     box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
//     transform: translateY(-4px);
//   }

//   .job-description {
//     font-size: 13px;
//     color: var(--text-color);
//     line-height: 1.5;
//     flex-grow: 1;              // ← pushes posted date to bottom
//     overflow: hidden;
//     text-overflow: ellipsis;
//     display: -webkit-box;
//     -webkit-line-clamp: 5;     // ← limits to 5 lines
//     -webkit-box-orient: vertical;
//     margin: 0;
//   }

//   .job-posted {
//     font-size: 12px;
//     color: var(--text-color);
//     opacity: 0.7;
//     margin-top: auto;          // ← always sticks to bottom
//   }
// `;
const NoJobsMessage = styled.p`
  text-align: center;
  color: var(--text-color);
  font-size: 29px;
  font-weight:600;
  margin-top: 100px;
  opacity: 0.8;
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 48px;
  gap: 4px;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  span {
    cursor: pointer;
    padding: 6px 10px;
    border-radius: 6px;
    transition: all 0.2s ease;
    color: var(--text-color);
    font-size: 14px;
    min-width: 32px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    &.selectedPage {
      background-color: var(--button-bg);
      color: #ffffff;
      font-weight: 500;
    }

    &:hover:not(.selectedPage) {
      background-color: #f3f4f6;
    }
  }
`;


const JobList = ({
  jobs,
  error,
  renderHTML,
  navigateToDetails,
  customerName,
  setfilters,
  filters,
}) => {
  const [theme, setTheme] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [isListView, setIsListView] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [page, setPage] = useState(1);

  const navigate = useNavigate();
const [search] = useSearchParams();

  const styleUrl = `${BaseUrl}/customer/getEmbededCodeSettings?customerName=${customerName}`;

  useEffect(() => {
    const fetchThemes = async () => {
      if (customerName === "undefined" || customerName === undefined) return;
      const fetchedTheme = await fetchStyle(styleUrl);
      setTheme(fetchedTheme);
    };
    fetchThemes();
  }, [styleUrl]);

  const handleJobClick = (job) => {
    setSelectedJob(job);
  };



  useEffect(() => {
    if (isListView && !selectedJob && jobs.length > 0) {
      const latestJob = jobs[0];
      setSelectedJob(latestJob);
    }
  }, [isListView, jobs, selectedJob]);

  // ---------- Pagination + Search logic ----------
  // const filteredJobs = jobs.filter((job) =>
  //   job?.job_title?.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  const filteredJobs = jobs.filter((job) => {
  const search = searchQuery.toLowerCase();
  const location = filters?.location?.toLowerCase() || "";

  const titleMatch = job?.job_title?.toLowerCase().includes(search);

  const city = job?.job_city?.toLowerCase() || "";
  const country = job?.job_country?.toLowerCase() || "";

  const locationMatch =
    !location || city.includes(location) || country.includes(location);

  return (!search || titleMatch) && locationMatch;
});

  const itemsPerPage = 6;
  const totalPages = Math.ceil(filteredJobs.length / itemsPerPage);

  const selectedPage = (pages) => {
    if (pages >= 1 && pages <= totalPages && pages !== page) {
      setPage(pages);
    }
  };

const decodeAndTruncate = (htmlString, maxWords = 30) => {
  if (!htmlString) return "";

  // First decode HTML entities (&nbsp; → space, &amp; → &, etc.)
  const decoded = htmlString
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");

  // Remove any remaining HTML tags
  const plainText = decoded.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();

  // Truncate to max words
  const words = plainText.split(' ');
  const truncated = words.slice(0, maxWords).join(' ');

  return truncated + (words.length > maxWords ? '...' : '');
};

  function ensureMySQLDateTime(dateTimeString) {
    if (!dateTimeString) return null;
    const parsedDate = new Date(dateTimeString);
    if (isNaN(parsedDate.getTime())) return null;
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const day = String(parsedDate.getDate()).padStart(2, "0");
    const hours = String(parsedDate.getHours()).padStart(2, "0");
    const minutes = String(parsedDate.getMinutes()).padStart(2, "0");
    const seconds = String(parsedDate.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const renderJobs = () => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const jobsToRender = [...filteredJobs].slice(startIndex, endIndex);

    return jobsToRender.map((job, index) => (
      <JobCard key={index} onClick={() => navigateToDetails(job?.job_id)}>
        <div className="job-header">
          <span className="experience-badge" style={{fontSize:'12px'}}>
            Experience: {job?.relevant_experience ?? "Not specified"} years
          </span>
          <span className="location-info" style={{fontSize:'12px'}}>
  <MdLocationOn />
  {job?.job_location_type?.trim()?.toLowerCase() === "remote"
    ? "Remote"
    : job?.job_city !== "Not Found" && job?.job_country !== "Not Found"
    ? `${job.job_city}, ${job.job_country}`
    : "-"}
</span>
        </div>

        <h2>
          <a
            href="#"
            className="job-title-link"
            onClick={(e) => {
              e.preventDefault();
              navigateToDetails(job?.job_id);
            }}
          >
            {job?.job_title}
          </a>
        </h2>

        {/* <p className="job-description">
          {renderHTML(
            job?.job_description?.split(" ").slice(0, 20).join(" ") + "..."
          )}
        </p> */}
       <p className="job-description">
  {decodeAndTruncate(job?.job_description)}
</p>

        {/* <p className="job-posted">
          {job?.created_at || ensureMySQLDateTime(new Date())}
        </p> */}


        {/* <p className="job-posted">Job Type:
  {job?.job_type || "Job Type Not Available"}
</p> */}
<div className="job-card-footer">
  <span className="job-type-text" style={{fontSize:'12px'}}>
    Job Type: {job?.job_type || "Not Available"}
  </span>

  <button
  className="apply-btn-card"
  onClick={(e) => {
    e.stopPropagation(); // prevent card click
    navigate(
      `/api/iframe/job?who=${encodeURIComponent(
        search.get("who")
      )}&jobid=${job.job_id}&apply=true`
    );
  }}
>
  Apply
</button>
</div>

      </JobCard>
    ));
  };

  // ---------- Render ----------
  return (
   <ThemeWrapper theme={theme}>
  <ContentWrapper>
    <SearchContainer>
      <SearchForm>
        <SearchRow>
          <SearchInputWrapper>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <SearchInput
              type="text"
              placeholder="Search for job Title..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </SearchInputWrapper>
          <ViewJobsButton>View Jobs</ViewJobsButton>
        </SearchRow>

        <FilterRow>
          <FormLabel>
              <label style={{paddingLeft:'8px'}}>Experience Level</label>
              <select
              className="no-border-select"
              // style={{padding:'10px'}}
                value={filters?.exp}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length > 0) {
                    setfilters({ ...filters, exp: e.target.value });
                  }
                }}
              >
                <option> Select</option>
                <option value={"0-2"}>  0-2</option>
                <option value={"2-4"}>  2-4</option>
                <option value={"4-6"}>  4-6</option>
                <option value={"6-8"}>  6-8</option>
                <option value={"8-10"}>  8-10</option>
                <option value={"10-12"}>  10-12</option>
                <option value={"12-14"}>  12-14</option>
              </select>
          </FormLabel>
          {/* <FormLabel>
            <label style={{paddingLeft:'2px'}} >Location</label>
            <input
              type="text"
              style={{ border: "none", outline: "none" }}
              placeholder="Enter city or country"
              value={filters?.city || ""}
              onChange={(e) => {
                const value = e.target.value.trim();
                // setfilters({ ...filters, location: value });
                setfilters({ ...filters, city: value });
              }}
            />
          </FormLabel> */}
          <FormLabel>
  <label style={{ paddingLeft: '2px' }}>Location</label>
  <input
    type="text"
    style={{ border: "none", outline: "none" }}
    placeholder="Enter city or country"
    value={filters?.location || ""}
    onChange={(e) => {
      const value = e.target.value.trim().toLowerCase();
      setfilters({ ...filters, location: value });
    }}
  />
</FormLabel>
         
          <FormLabel>
  <label style={{paddingLeft:'8px'}}>Job Type</label>
  <select
    className="no-border-select"
    value={filters?.type}
    onChange={(e) => {
      setfilters({ ...filters, type: e.target.value });
    }}
  >
    <option value="">  All Categories</option>
    <option value="Full Time">  Full Time</option>
    <option value="Contractual">  Contractual</option>
    <option value="C2H">  C2H</option>
  </select>
</FormLabel>

        </FilterRow>
      </SearchForm>
    </SearchContainer>

    <HeaderSection>
      <JobCount>Showing {filteredJobs.length} Total Jobs</JobCount>
      <ViewToggle>
        <ToggleButton onClick={() => setIsListView(false)} active={!isListView}>
          Card View
        </ToggleButton>
        <ToggleButton onClick={() => setIsListView(true)} active={isListView}>
          List View
        </ToggleButton>
      </ViewToggle>
    </HeaderSection>

    {/* ---------- JOB DISPLAY SECTION ---------- */}
    {isListView ? (
      <div className="jb-job-board-container">
        {filteredJobs.length > 0 ? (
          <>
            <div className="jb-job-list">
              {filteredJobs
                .map((job, index) => (
                  <div
                    key={index}
                    className={`jb-job-item ${
                      selectedJob && selectedJob.job_id === job.job_id
                        ? "active"
                        : ""
                    }`}
                    onClick={() => handleJobClick(job)}
                  >
                    <div className="jsd-job-header">
                      <span className="experience-badge">
                        Experience: {`${job?.relevant_experience || "-"} Years`}
                      </span>
                      <span className="location-info">
                        <MdLocationOn className="jsd-jobheader" />
                       {job?.job_location_type?.trim()?.toLowerCase() === "remote"
  ? "Remote"
  : job?.job_city !== "Not Found" && job?.job_country !== "Not Found"
  ? `${job.job_city}, ${job.job_country}`
  : "-"}
                      </span>
                    </div>

                    <h2>
                      <a
                        href="#"
                        className="job-title-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handleJobClick(job);
                        }}
                      >
                        {job?.job_title}
                      </a>
                    </h2>

                    {/* <p className="job-description">
                      {renderHTML(
                        job?.job_description
                          ?.split(" ")
                          .slice(0, 20)
                          .join(" ") + "..."
                      )}
                    </p> */}
                     <p className="job-description">
  {decodeAndTruncate(job?.job_description)}
</p>

                    <p className="job-posted"> Job Type:
                       {job?.job_type || "Not Available"}
                    </p>
                  </div>
                ))}
            </div>

            <div className="jb-job-details">
              {selectedJob ? (
                <JobDetails
                  job_id={selectedJob?.job_id}
                  customernameFromUrl={customerName}
                  renderHTML={renderHTML}
                  isListView={isListView}
                />
              ) : (
                <p>Select a job to see details</p>
              )}
            </div>
          </>
        ) : (
          <NoJobsMessage>No jobs available on this search</NoJobsMessage>
        )}
      </div>
    ) : filteredJobs.length > 0 ? (
      <JobContainer className="card-view">{renderJobs()}</JobContainer>
    ) : (
      <NoJobsMessage>No jobs available on this search</NoJobsMessage>
    )}

    {!isListView && filteredJobs.length > 0 && (
      <Pagination>
        <span onClick={() => selectedPage(page - 1)}>
          <GrFormPrevious size={18} />
        </span>
        {[...Array(totalPages)].map((_, i) => (
          <span
            key={i}
            onClick={() => selectedPage(i + 1)}
            className={page === i + 1 ? "selectedPage" : ""}
          >
            {i + 1}
          </span>
        ))}
        <span onClick={() => selectedPage(page + 1)}>
          <GrFormNext size={18} />
        </span>
      </Pagination>
    )}
  </ContentWrapper>
</ThemeWrapper>

  );
};

export default JobList;
